import { tutorMonthlyScoreConstants } from "@data/constants/tutorMonthlyScoreConstants"

export function hideResetModal() {
    return {
        type: tutorMonthlyScoreConstants.HIDE_RESET_MODAL,
    }
}
